import { render, staticRenderFns } from "./MallSelector.vue?vue&type=template&id=1fba8d63&"
import script from "./MallSelector.vue?vue&type=script&lang=ts&"
export * from "./MallSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports